import {Pipe, PipeTransform} from '@angular/core';
import moment from "moment";
import {dateFormat} from "../shared/variables/variables";

@Pipe({
  name: 'calendar'
})
export class CalendarPipe implements PipeTransform {

  transform(value: any): any {
    return moment(value).fromNow();
  }

}
